<template>
  <StepTemplate :activeStepNr="this.activeStepNr"
                :myStepNr="this.myStepNr"
                :value="value"

  >
    <template slot="slide-form">
      <form data-vv-scope="xxx" @click.alt="testFillForm()">
        <!--============================================================================================================-->
        <!--
        <v-layout row>
            <v-flex xs11 class="mt-2"><h5>{{this.label}}</h5></v-flex>
        </v-layout>
        -->
        <!--============================================================================================================ -->
        <v-layout row class="section_header">
          <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Antrag-Daten</h6></v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <v-flex xs12 style=" font-size: 0.9em;">
            <Anzeigepflicht-Block><!-- TextBlock mit Hinweis zur Pflicht alle Daten korrekt anzugeben--></Anzeigepflicht-Block>
          </v-flex>
        </v-layout>

        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            Tragen Sie hier die Straße ein, in der sich der zu versichernde Hausrat befindet.
          </Rechner-hint-col>
          <v-flex xs7>
            <Rechner-field-col :fielddef="fieldDefs.hr_lage_strasse" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
          <v-flex xs3>
            <Rechner-field-col :fielddef="fieldDefs.hr_lage_strasse_nr" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            Tragen Sie hier die Postleitzahl und den Ort ein, in der sich der zu versichernde Hausrat befindet.
            <br>
            <br>Diese Daten werden benötigt, da jeder Postleitzahl eine sogenannte Tarifzone zugeordnet ist.
          </Rechner-hint-col>
          <v-flex xs4>
            <Rechner-field-col :fielddef="fieldDefs.hr_lage_plz" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
          <v-flex xs6>
            <Rechner-field-col ref="selectOrt" :fielddef="fieldDefs.hr_lage_ort" v-model="value.fieldValues"
                               :$v="$v" menuIsActive="selectInput_ort_open"></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            <b>Gebäudeart</b>
            <br>Tragen Sie hier bitte die Gebäudeart ein, in welchem sich der zu versichernde Hausrat befindet.
            <br>
            <b>Wohnfläche</b>
            <br>Bitte geben Sie hier Ihre qm-Wohnfläche an. Die Wohnfläche ist für die Berechnung der Versicherungssumme notwendig.
            Die Wohnfläche ist die Grundfläche aller Räume, einschließlich Hobbyräume, Wintergärten und Arbeitszimmer. Nicht zur Wohnfläche zählen Balkone und Terrassen.

          </Rechner-hint-col>
          <v-flex xs4>
            <Rechner-field-col :fielddef="fieldDefs.hr_typ_gebaeude" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
          <v-flex xs6>
            <Rechner-field-col :fielddef="fieldDefs.hr_qm" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            Ihre Fahrräder sind außerhalb Ihrer Wohnung / Ihres Hauses nicht automatisch gegen Diebstahl versichert.
            <br>
            <br>Tragen Sie hier den Wert Ihrer Fahrräder ein, um auch unterwegs gegen Diebstahl geschützt zu sein.
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.hr_typ_fahrrad"
                               v-model="value.fieldValues"
                               direction="row"
                               :$v="$v"
            ></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            In der Elementarversicherung können zusätzlich Schäden versichert werden gegen:
            <ul>
              <li>Überschwemmung</li>
              <li>Rückstau</li>
              <li>Erdbeben</li>
              <li>Erdsenkung</li>
              <li>Erdrutsch</li>
              <li>Schneedruck</li>
              <li>Lawinen</li>
              <li>Vulkanausbrüche</li>
            </ul>
            Eine endgültige Prüfung für den Einschluss der Elementarversicherung erfolgt
            bei der Antragsprüfung in der Hausptverwaltung!
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.hr_jn_elementar"
                               v-model="value.fieldValues"
                               direction="row"
                               :$v="$v"
            ></Rechner-field-col>
          </v-flex>
        </v-layout>
        <v-layout row v-show="value.fieldValues.hr_jn_elementar==1" style="margin: -20px 0 0 0;">
          <v-flex xs1>
          </v-flex>
          <v-flex xs10
                  style="font-size:0.9rem; background: rgb(255, 247, 188); font-style: italic;margin:7px 0 0 9px;">
            Eine endgültige Prüfung für den Einschluss der Elementarversicherung erfolgt
            bei der Antragsprüfung in der Hausptverwaltung!
          </v-flex>
        </v-layout>

        <!------------------------------------------------------------------------------------------------------------>

        <v-layout row>
          <Rechner-hint-col>
            Eine Unterversicherung liegt vor,<br>wenn der tatsächliche Wert des zu versichernden Hausrates höher ist als<br>die vereinbarte Versicherungssumme.
            <br>
            <br>Die Entschädigungsleistung wird im Versicherungsfall entsprechend gekürzt.
            Bei der Gewährung des Unterversich-erungsverzichts, wird auf die Prüfung einer möglichen Unterversicherung verzichtet.
            <br>
            <br>Gewährung des Unterversicherungs-verzichts bei mind. 650,00 EUR je <br>qm-Wohnfläche.
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.hr_jn_untervers_schutz"
                               v-model="value.fieldValues"
                               direction="row"
                               :$v="$v"
            ></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <transition name="slide">
          <v-layout row v-if="parseInt(value.fieldValues.hr_jn_untervers_schutz,10) === 0">
            <Rechner-hint-col>
              In der Hausratversicherung besteht Anspruch auf die Wiederherstellung der beschädigten Sachen in gleicher Art und Güte im neuwertigen Zustand. Aus diesem Grund sollte die
              Versicherungssumme möglichst genau dem Wert Ihres Hausrates (Möbel, Wertsachen etc.) entsprechen.
            </Rechner-hint-col>
            <v-flex xs10>
              <Rechner-field-col :fielddef="fieldDefs.hr_vers_summe"
                                 v-model="value.fieldValues"
                                 direction="row"
                                 :$v="$v"

              ></Rechner-field-col>
            </v-flex>
          </v-layout>
        </transition>
        <!------------------------------------------------------------------------------------------------------------>

        <v-layout row>
          <Rechner-hint-col>
            Als Wohngemeinschaft zählt eine Gruppe von Personen, die keine Familie sind und sich gemeinsam eine Wohnung teilen.
            <br>
            Es kann nur der Hausrat der gesamten Wohnung versichert werden (keine einzelnen Zimmer versicherbar).
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.hr_jn_wohngemeinschaft"
                               v-model="value.fieldValues"
                               direction="row"
                               :$v="$v"
                               :key="'update_Hack_'+value.fieldValues.hr_jn_untervers_schutz"
            ></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <transition name="slide">
          <v-layout row v-if="parseInt(value.fieldValues.hr_jn_wohngemeinschaft,10) === 1">
            <Rechner-hint-col>
              Bitte benennen Sie hier bei einer Wohngemeinschaft die Namen der Personen, die mit in der zu versichernden Wohnung leben.
            </Rechner-hint-col>
            <v-flex xs10>
              <Rechner-field-col :fielddef="fieldDefs.hr_mitbewohner"
                                 v-model="value.fieldValues"
                                 direction="row"
                                 :$v="$v"
              ></Rechner-field-col>
            </v-flex>
          </v-layout>
        </transition>

        <!------------------------------------------------------------------------------------------------------------>

        <!--============================================================================================================-->


        <!--
        <v-layout row class="section_header">
            <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Fragen zum Vertrag</h6></v-flex>
        </v-layout>
        -->
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            Sie können den Versicherungsbeginn bestimmen!
            <br>Der Beginn ist frühestens am nächsten Tag möglich.
            <br>Der Versicherungsbeginn sollte jedoch maximal einen Tag später sein, zu dem Ihre bisherige Versicherung aufgehoben wurde.
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.vertrag_beginn" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            Hier können Sie wählen, ob der Versicherungs-Beitrag einmal im Jahr, halbjährlich oder vierteljährlich gezahlt werden soll.
            <br>Eine monatliche Zahlweise ist nicht möglich.
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.vertrag_zahlungsweise" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!--============================================================================================================-->
      </form>

    </template>
  </StepTemplate>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
import slideMixin from '../stepMixin'
import _ from 'lodash'
import numeral from "numeral";
//import VBtn from "../../../../node_modules/vuetify/src/components/VBtn/VBtn.vue";
//import {mapState} from 'vuex'

export default {
  //========================================================================================================
  name: 'Step_hausrat_I',
  label: 'Haus/Wohnung Daten',
  label2: 'Daten zum<br>Haus/Wohnung',
  forceUpdateDummy: 1,
  fieldKeys: [
    'vertrag_zahlungsweise',
    'vertrag_beginn',

    'hr_lage_strasse',
    'hr_lage_strasse_nr',
    'hr_lage_ort',
    'hr_lage_plz',

    'hr_qm',

    'hr_typ_fahrrad',
    'hr_typ_gebaeude',

    'hr_jn_elementar',
    'hr_jn_untervers_schutz',
    'hr_jn_wohngemeinschaft',
    'hr_mitbewohner',

    'hr_vers_summe',

  ],
  //========================================================================================================
  data: function () {
    //fieldDefs wird in StepMixin mit den Werten aus der Datenbank belegt,
    //an dieser Stelle können diese Werte überschrieben werden.
    // Vue merged von alleine die Werte aus 'stepMixin' und denen aus 'fieldDefs_OVERRIDE'
    var fieldDefs_OVERRIDE = {}

    return {
      fieldDefs: fieldDefs_OVERRIDE,
      testList: [1, 2, 3, 4, 5],
      field: null,
      selectInput_ort_open: true,

    }
  }, //========================================================================================================
  mixins: [slideMixin],
  //===========================================================================================================
  watch: {

    value: {
      handler: function (newVal, oldVal) {
        console.log("WATCHER fieldValues in ", this.$options.label)
        var fV = this.value.fieldValues
        var fVold = this.frmValuesOld
        var earlyExit = true;
        for (var key in fV) {
          if (fV[key] !== fVold[key]) {
            earlyExit = false;
            console.log("changed ", key, fVold[key], '->', fV[key])
            this.update_Ort_by_PLZ(key)
          }
        }
        if (earlyExit === true) {
          console.log("NO changes -> early EXIT")
          return;
        }
        //----------------------------------------------------------------------------
        // -> hier evtl. reaktion auf Änderungen von Form-Values
        if ((fV.hr_qm > 0 || fVold.hr_qm > 0) && fV.hr_qm !== fVold.hr_qm) {
          console.log("Quadratmeter changed !")
          this.forceUpdateDummy = this.forceUpdateDummy + 1

          var x = numeral(this.value.fieldValues['hr_vers_summe']).value()
          this.$v.$reset();
          this.$v.$touch();
          this.$forceUpdate();
          this.value.fieldValues['hr_vers_summe'] = x
          this.$nextTick(function () {
            this.$forceUpdate();
            this.$v.$reset();
            this.$v.$touch();
          })


        }
        //----------------------------------------------------------------------------

        this.frmValuesOld = _.assign({}, fV)
      },
      deep: true,
    },
  }, //===========================================================================================================
  methods: {
    test: function () {
      window.test = this
    }
  }, //========================================================================================================
  components: {/* programmatically setted by step-mixin*/},
  //===========================================================================================================
  props: [/* programmatically setted by step-mixin*/],
  //===========================================================================================================
  // HOOKS:
  /* programmatically setted by step-mixin*/
  //===========================================================================================================
}
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style>

</style>
